import { Input } from "@progress/kendo-react-inputs";

export const MaxLengthProperty = {
  propertyName: "MaxLength",
  propertyDisplay: "Max Length",
  propertyType: "number",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Input
        name={this.propertyName}
        type={"number"}
        onBlur={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || ""}
      />
    );
  },
};
